import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState } from "../appState/models";
import { ProjectState } from "./model";

export const projectSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.project.project,
);

export const keyDetailsSelector = createDraftSafeSelector(
  projectSelector,
  (state) => state.keyProjectDetails,
);

export const childProgramNavigationSelector = createDraftSafeSelector(
  projectSelector,
  (state) => state.isStartChildProgramNavigation,
);

export const projectStatusSelector = createDraftSafeSelector(
  projectSelector,
  (state) => state.projectStatus,
);

export const projectFrameworkIdSelector = createDraftSafeSelector(
  projectSelector,
  (state) => state.keyProjectDetails?.projectFramework?.id,
);

export const projectCountryPermissionSelector = createDraftSafeSelector(
  projectSelector,
  (state) => state.isEditable,
);

export const projectBillingCountryIdSelector = createDraftSafeSelector(
  keyDetailsSelector,
  (state) => state?.billingCountryId,
);

export const projectOpcoFieldEditableSelector = createDraftSafeSelector(
  projectSelector,
  (state: ProjectState) => state.areOpcoFieldsEditable,
);
